// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuDropdown_button__3r3N0","buttonVariant":"MenuDropdown_buttonVariant__1ZIdV","disabled":"MenuDropdown_disabled__18zQ_","menuList":"MenuDropdown_menuList__1lhCX"};